<template>
  <div
    :class="[
      'h-5/6 border rounded-lg shadow absolute top-8 right-1 bg-white z-10',
      { 'w-10': !unassignedOpen },
      { 'w-80': unassignedOpen }
    ]"
  >
    <div
      v-if="!unassignedOpen"
      class="flex flex-col gap-4 cursor-pointer"
      @click="toggleUnassignedColumn"
    >
      <ChevronLeft class="h-5 mt-3 cursor-pointer" />
      <div class="relative flex items-center justify-center">
        <div
          class="absolute inline-flex items-center justify-center w-5 h-5 text-xxs font-bold text-white bg-red-600 border-2 border-white rounded-full -top-2 right-0"
        >
          {{ unassignedEvents.length }}
        </div>
        <WarningIcon class="h-5 text-yellow-700" />
      </div>
      <div class="rotate-90 whitespace-nowrap w-full font-medium">
        Unassigned Appointments
      </div>
    </div>
    <div v-else class="p-4 flex flex-col gap-4 max-h-full">
      <div
        class="flex justify-between cursor-pointer"
        @click="toggleUnassignedColumn"
      >
        <div class="flex gap-4 items-center">
          <div class="relative flex items-center justify-center">
            <div
              class="absolute inline-flex items-center justify-center w-5 h-5 text-xxs font-bold text-white bg-red-600 border-2 border-white rounded-full -top-2 -right-2"
            >
              {{ unassignedEvents.length }}
            </div>
            <WarningIcon class="h-5 text-yellow-700" />
          </div>
          <div class="whitespace-nowrap w-full font-medium">
            Unassigned Appointments
          </div>
        </div>
        <div class="flex items-center gap-2">
          <div
            class="rounded-lg p-1 hover:bg-gray-100 cursor-pointer"
            data-tippy-content="Put At Top of Schedule"
            @click="toggleUnassignedPreference"
          >
            <DockIcon class="w-4" />
          </div>
          <CollapseLogo class="w-4 text-gray-400 cursor-pointer rotate-180" />
        </div>
      </div>
      <div class="overflow-y-auto max-h-full p-[1px]">
        <UnassignedEvents />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref } from "vue";
import { useStore } from "vuex";
import { initTippyTooltips } from "@/lib/helpers";

import WarningIcon from "@/images/alert-triangle.svg?component";
import ChevronLeft from "@/images/chevron-left.svg?component";
import DockIcon from "@/images/dock-icon.svg?component";
import CollapseLogo from "@/images/log-in.svg?component";
import { useEventCalendar } from "@/SchedulerV2/useEventCalendar";
import UnassignedEvents from "./UnassignedEvents.vue";

const { unassignedEvents } = useEventCalendar();
const unassignedOpen = ref(false);
const store = useStore();

const toggleUnassignedColumn = async () => {
  unassignedOpen.value = !unassignedOpen.value;
  if (unassignedOpen.value) {
    await nextTick();
    initTippyTooltips();
  }
};

const toggleUnassignedPreference = () => {
  store.dispatch("disablePreference", "sheduler_unassigned_events_floating");
  // refresh schedule
  window.location.reload();
};
</script>
